import React from 'react';
import { TextInput } from 'react-admin';
import Box from '@mui/material/Box';

export const EfficiencyTestObservationsField = () => {
  return (
    <Box
      sx={{
        width: '100%',
        marginTop: 2
      }}
    >
      <TextInput
        rows="3"
        source="observations"
        label="resources.efficiency-tests.fields.observations"
        multiline={true}
        fullWidth={true}
      />
    </Box>
  );
};
